import { Routes, Route } from 'react-router-dom'
import { Briefcase, Users, Clock, User } from 'lucide-react'
import BottomNav from '../components/navigation/BottomNav.tsx'
import AppHeader from '../components/navigation/AppHeader.tsx'
import MyJobsPage from '../pages/practice/MyJobsPage.tsx'
import PostJobPage from '../pages/practice/PostJobPage.tsx'
import CandidatesPage from '../pages/practice/CandidatesPage.tsx'
import TimesheetsPage from '../pages/practice/TimesheetsPage.tsx'
import ProfilePage from '../pages/practice/ProfilePage.tsx'

const practiceTabs = [
  {
    id: 'jobs',
    label: 'My Jobs',
    icon: Briefcase,
    path: '/practice/jobs'
  },
  {
    id: 'candidates',
    label: 'Candidates',
    icon: Users,
    path: '/practice/candidates'
  },
  {
    id: 'timesheets',
    label: 'Timesheets',
    icon: Clock,
    path: '/practice/timesheets'
  },
  {
    id: 'profile',
    label: 'Profile',
    icon: User,
    path: '/practice/profile'
  }
]

export default function PracticeLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <AppHeader />

      <main className="flex-1 pb-16">
        <Routes>
          <Route path="/practice/jobs" element={<MyJobsPage />} />
          <Route path="/practice/jobs/new" element={<PostJobPage />} />
          <Route path="/practice/jobs/:jobId" element={<PostJobPage />} />
          <Route path="/practice/candidates" element={<CandidatesPage />} />
          <Route path="/practice/timesheets" element={<TimesheetsPage />} />
          <Route path="/practice/profile" element={<ProfilePage />} />
          <Route path="/" element={<MyJobsPage />} />
        </Routes>
      </main>

      <BottomNav tabs={practiceTabs} />
    </div>
  )
}
